import Vue from "vue";
import Ionic from "@ionic/vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import VueObserveVisibility from "vue-observe-visibility";
import VueAudioRecorder from "vue-audio-recorder";
import VueCordova from "vue-cordova";

import PullToRefresh from "pulltorefreshjs";
import moment from "moment";
import _ from "lodash";

// Vue.use(styles);
Vue.use(VueAxios, axios);
Vue.use(VueObserveVisibility);
Vue.use(VueAudioRecorder);
Vue.use(VueCordova);

Vue.config.productionTip = false;
Vue.use(Ionic);

import { api } from "./mixins/api.js";
Vue.mixin(api);

let deviceReady = false;
let vueReady = false;
let pushId = null;
let device = {};
let iap = {};
let iapProducts = [];

const app = new Vue({
    router,
    render: h => h(App),
    data: function() {
        return {
            userToken: null,
            user: {
                id: null,
                name: null,
                email: null,
                is_creator: false,
                is_admin: false,
                avatar: null,
                profile: "",
                expires_at: null,
                subscribe_at: null,
                years: null,
                storage: null
            },
            showMenu: null,
            device: null,
            notification: {
                id: 0,
                type: ""
            },
            iap: {},
            iapProducts: []
        };
    },
    watch: {
        // eslint-disable-next-line
        $route(to, from) {
            // console.log('routing', from, to);
            this.closeMenu();
            PullToRefresh.destroyAll();
        }
        // isCordova: {
        //     immediate: true,
        //     handler: function(newVal, oldVal) {
        //         console.log("isCordova check", this.isCordova, Vue.cordova);
        //         if (newVal && !oldVal && !this.device) {
        //             this.init();
        //         }
        //     }
        // }
    },
    mounted: function() {
        vueReady = true;
        if (deviceReady) {
            this.init();
        }
    },
    created: function() {
        let rname = this.$route.name;
        console.log("LOADED ROUTE", rname);
        if (localStorage.getItem("ghost.user") && localStorage.getItem("ghost.userToken")) {
            this.user = JSON.parse(localStorage.getItem("ghost.user"));
            this.userToken = localStorage.getItem("ghost.userToken");
            this.axios.defaults.headers.common.Authorization = "bearer " + this.userToken;
            if (rname == "upgrade" || rname == "profile") {
                // do nothing if it's one of these routes
                return;
            }
            this.$router.push({ name: "home" });
        } else {
            if (rname == "resetpassword" || rname == "register" || rname == "password" || rname == "login") {
                // do nothing if it's one of these routes
                return;
            }
            this.$router.push({ name: "login" });
        }
    },
    computed: {
        // isCordova : function () {
        //     if (Vue.cordova.deviceready) {
        //         return Vue.cordova.deviceready;
        //     }
        //     return false;
        // }
    },
    methods: {
        init: function() {
            console.debug("inititating App");
            this.device = null;
            localStorage.removeItem("ghost.device");
            this.setPushId();
        },
        back: function() {
            this.$router.go(-1);
        },
        getYears: function(start, end) {
            if (start && end) {
                let start_time = moment(start),
                    end_time = moment(end);
                if (start_time.isValid() && end_time.isValid()) {
                    var duration = moment.duration(end_time.diff(start_time));
                    return _.floor(duration.as("years"));
                }
            }
            return null;
        },
        setUser: function(obj) {
            this.user = {
                id: obj.id,
                name: obj.name,
                email: obj.email,
                is_creator: obj.is_creator,
                is_admin: obj.is_admin,
                avatar: obj.avatar,
                profile: obj.profile,
                expires_at: obj.expires_at,
                subscribe_at: obj.subscribe_at,
                years: this.getYears(obj.subscribe_at, obj.expires_at),
                storage: obj.storage_info
            };
            localStorage.setItem("ghost.user", JSON.stringify(this.user));
            this.setPushId();
        },
        setUserToken: function(token) {
            this.axios.defaults.headers.common.Authorization = "bearer " + token;
            this.userToken = token;
            localStorage.setItem("ghost.userToken", this.userToken);
        },
        logout: function() {
            this.userToken = null;
            this.user = {
                id: null,
                name: null,
                email: null,
                is_creator: false,
                is_admin: false,
                avatar: null,
                profile: ""
            };
            localStorage.removeItem("ghost.user");
            localStorage.removeItem("ghost.userToken");
            localStorage.removeItem("ghost.device");
            this.$router.push({ name: "login" });
        },
        openMenu: function() {
            this.showMenu = true;
        },
        closeMenu: function() {
            if (this.showMenu) {
                this.showMenu = false;
            }
        },
        storeDevice: function(device) {
            this.device = device;
            console.log("DEVICE", this.device);
            localStorage.setItem("ghost.device", JSON.stringify(device));
            console.debug("Device Saved", device);
        },
        setPushId: function() {
            let device = Vue.cordova.device;
            if (!device) {
                console.log("No device recorded");
                return;
            }
            if (!this.user.id) {
                console.log("No user ID recorded");
                return;
            }
            if (!device.uuid || (device.platform != "Android" && device.platform != "iOS")) {
                console.debug("Platform is", device.platform);
                return;
            }
            this.storeDevice(device);
            if (!pushId) {
                console.log("No push ID recorded");
                return;
            }
            let params = {
                device: JSON.stringify(device),
                device_id: pushId
            };
            this.axios
                .post(this.api + "users/device", params)
                .then(response => {
                    console.log("REGISTERED DEVICE", response.data);
                    if (response.data.error) {
                        console.error("Error saving device info", response.data.msg);
                    }
                })
                .catch(error => {
                    console.error("Error sending device info", error);
                });
        },
        // setDevice : function () {
        //     console.debug('pushId is ', pushId);
        //     console.debug('device is ', this.device);
        //     if (!this.device && pushId != null) {
        //         // if it's in local storage, use that
        //         // if (localStorage.getItem('ghost.device')) {
        //         //     console.log('using stored device');
        //         //     var stored_device = localStorage.getItem('ghost.device');
        //         //     if (stored_device) {
        //         //         this.device = JSON.parse(stored_device);
        //         //         return;
        //         //     }
        //         // }
        //         // if we have the device information from cordova check and store it
        //         let self   = this,
        //             device = Vue.cordova.device;
        //         if (!device) {
        //             console.debug('No cordova device was found');
        //             this.storeDevice(false);
        //             return;
        //         }
        //         // if it's not android or ios, store it but don't send it
        //         if (!device.uuid || (device.platform != 'Android' && device.platform != 'iOS')) {
        //             console.debug('Platform', device.platform);
        //             this.storeDevice(device);
        //             return;
        //         }
        //         if (this.user.id) {
        //             // send it to the API
        //             let params = {
        //                 device    : JSON.stringify(device),
        //                 device_id : pushId
        //             };
        //             console.debug('Device Parameters', params);
        //             this.axios.post(this.api + 'users/device', params)
        //                 .then(response => {
        //                     console.log('Send device', response.data)
        //                     if (response.data.error) {
        //                         // if it errors, log an error, and don't save it so that we can retry
        //                         console.error('Error saving device info', response.data.msg);
        //                     } else {
        //                         self.storeDevice(device);
        //                     }
        //                 })
        //                 .catch(error => {
        //                     console.error('Error sending device info', error);
        //                 });
        //         }
        //     }
        //     else {
        //         console.log('device exists, push id is null', this.device, pushId);
        //     }
        // },
        notificationClicked: function(data) {
            console.log("Notification clicked", data);
            if (data.additionalData && data.additionalData.ghost) {
                this.setNotification(data.additionalData.ghost);
            }
            // if it's a text message or image, open that thread - need a new route adding
            // if it's a video or call, open the 'call waiting' screen - need a new route adding
        },
        clearNotification: function() {
            this.notification = {
                id: 0,
                type: ""
            };
        },
        setNotificstion: function(str) {
            let data = JSON.parse(str);
            console.log("MESSAGE INFO", data);
            this.notification = {
                id: data.id,
                type: data.type
            };

            // then redirect to that page
        }
    }
}).$mount("#app");

// // Event listeners for app at top level
document.addEventListener(
    "deviceready",
    function() {
        console.debug("Device Ready");
        // screen.orientation.lock("portrait");
        deviceReady = true;
        if (vueReady) {
            app.init();
        }

        window.open = cordova.InAppBrowser.open;

        // StatusBar.hide();

        if (typeof PushNotification == "undefined") {
            console.debug("Push Notifications Not Available");
            return;
        }

        device = cordova.device;
        iap = cordova.inAppPurchase;

        let push = PushNotification.init({
            ios: {
                alert: true,
                badge: true,
                sound: true,
                clearBadge: true
            },
            android: {
                senderID: 988406483778,
                vibrate: true,
                forceShow: true,
                badge: true,
                sound: true,
                clearBadge: true,
                iconColor: "#20759a"
            }
        });

        push.on("registration", data => {
            console.debug("Push registered", data);
            pushId = data.registrationId;
            app.init();
        });

        push.on("notification", data => {
            console.debug("Push notification", data);
            // data.message,
            // data.title,
            // data.count,
            // data.sound,
            // data.image,
            // data.additionalData
            if (data.additionalData && data.additionalData.ghost) {
                let ghost = data.additionalData.ghost;
                console.log("GHOST", data.additionalData.ghost);
                if (ghost.type == "video") {
                    if (ghost.id) {
                        app.$router.push({ name: "videopage", params: { id: ghost.id } });
                    } else {
                        app.$router.push({ name: "videos" });
                    }
                } else if (ghost.type == "audio") {
                    if (ghost.id) {
                        app.$router.push({ name: "callpage", params: { id: ghost.id } });
                    } else {
                        app.$router.push({ name: "calls" });
                    }
                } else if (ghost.type == "image") {
                    app.$router.push({ name: "gallery" });
                } else if (ghost.type == "text") {
                    if (ghost.from) {
                        app.$router.push({ name: "messagepage", params: { id: ghost.from } });
                    } else {
                        app.$router.push({ name: "messages" });
                    }
                }
            }

            push.finish(function () {
                console.log('processing of push data is finished');
            }, function () {
                console.log('error with push', data.additionalData);
            });
        });

        push.on("error", function(error) {
            console.error("Push error", error);
            // error.message
        });
    },
    false
);

document.addEventListener(
    "backbutton",
    function() {
        // console.log('Back button triggered');
        app.back();
    },
    false
);
